import { render, staticRenderFns } from "./mailList.vue?vue&type=template&id=17ad8893&scoped=true&"
import script from "./mailList.vue?vue&type=script&lang=js&"
export * from "./mailList.vue?vue&type=script&lang=js&"
import style0 from "./mailList.vue?vue&type=style&index=0&id=17ad8893&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad8893",
  null
  
)

export default component.exports